import React from 'react'
import ResponsiveContainer from '../../../layouts/ResponsiveContainer'
import ObjetivesCard from '../../../components/Cards/ObjetivesCard'
import assignment from '../../../assets/icons/assignment.png'
import person from '../../../assets/icons/person_raised_hand.png'
import score from '../../../assets/icons/readiness_score.png'

const goals = [
    { id: '1', img: assignment, text: 'Relevar datos oficiales y optimizar su análisis' },
    { id: '2', img: score, text: 'Evaluar el estado de los derechos humanos y visibilizar vulneraciones estructurales' },
    { id: '3', img: person, text: 'Impulsar acciones que protejan esos derechos y promuevan su sostenibilidad' },
]

const GoalsAndObjectives = () => {
    return (
        <div className='flex justify-center bg-brand-green-30 w-full py-20 relative'>
            <ResponsiveContainer className='flex flex-col justify-center'>
                <div className='flex flex-col items-center gap-14'>
                    <h2 className='text-hmedium md:text-dsmall text-primary-100' >Metas y objetivos</h2>
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-14 w-full'>                        {
                        goals.map((goal) => (
                            <ObjetivesCard
                                key={goal.id}
                                img={goal.img}
                                text={goal.text}
                            />
                        ))
                    }
                    </div>
                </div>
            </ResponsiveContainer>
        </div>
    )
}

export default GoalsAndObjectives